import { render, staticRenderFns } from "./CommUser.vue?vue&type=template&id=71402417&scoped=true"
import script from "./CommUser.vue?vue&type=script&lang=js"
export * from "./CommUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71402417",
  null
  
)

export default component.exports